import { ClosestChallenge } from '../interfaces/ClosestChallenge';
import { apiService } from '../../shared/services/apiService';

export const challengeHomeService = {
  async getClosestChallenge() {
    const resp = await apiService.get<ClosestChallenge>(
      '/api/home-page/challenges/closest',
    );

    return resp.data;
  },
};
